/**
 * Clamps value to [min, max) interval (or [min,max] - depending on maxIncluded prop)
 * @param value - value to clamp
 * @param min - minimum allowed value
 * @param max - maximum allowed value
 * @param maxIncluded - defines if maximum allowed value is inclusive or exclusive (exclusive by default)
 */
const clamp = (
  value: number,
  min?: number,
  max?: number,
  maxIncluded = false,
): number => {
  if (typeof min === 'number' && value < min) {
    return min;
  }

  if (typeof max === 'number') {
    const maxIncludedValue = maxIncluded ? max : max - 1;

    if (value >= maxIncludedValue) {
      return maxIncludedValue;
    }
  }

  return value;
};

export default clamp;
